import { FlagsComponentRouter, FlagsSingleton } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'
import {
  isK5SiteSelection,
  isMsSiteSelection,
  isMiddleSchoolUrl,
  isFamilyResourcesPageInProgramFlex,
  isHighSchoolUrl,
} from 'utils/productHelpers'

// TODO REMOVE MIDDLE SCHOOL JUNE RELEASE: middle school june release allows us to keep this flag checker on. So DO NOT turn off or remve this flag
// until we have a replacement for it. Used in multiple places so update all of them at once
const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: [
    'feature_LEARN-20164-k5-site-selection',
    'feature_LEARN-20108-ms-site-selection',
    'middle-school-june-release',
  ],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) =>
    isMiddleSchoolUrl() ||
    isHighSchoolUrl() ||
    isFamilyResourcesPageInProgramFlex() ||
    isK5SiteSelection(_, subscribedFlags) ||
    isMsSiteSelection(_, subscribedFlags),
})

export default FlagToggler
